import React, { useContext, useEffect, useState } from "react";
import "./CustomerFormStyle.css";
import { useFormik } from "formik";
import { message, Spin } from "antd";
import * as Yup from "yup";
import CustomInput from "./CustomInput";
import "./OtpStyles.css";
// import { BsPlayCircle } from "react-icons/bs";
import DropDown from "./DropDown";
import MultiSelect from "./MultiSelect";
import { onecodeAPI } from "../AppConfig";
import _ from "lodash";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { FeatureFlagContext } from "../FeatureFlagContext";
import { isCharWithoutSymbol } from "../utils/regexConstants";
import { useDispatch } from "react-redux";
import { customerActions } from "../store/customerSlice";

// Mock Data
// 8ore7hMR8m1vq1agUcUaXVzr1JGzfRoGicOWxUuRe4f28yEJds4Usf8HGXkk15c4lndsHNrrglEiB%2BuS2eeNgA%3D%3D
export default function LastForm({ setCurrentScreen, isCreditScoreCheck, customerId}) {
  // States
  const [termsChecked, setTermsChecked] = useState(true);
  const [loading, setLoading] = useState(false);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [incomeOptions, setIncomeOptions] = useState([]);
  const [employmentTypeOptions, setEmploymentTypeOptions] = useState([]);
  const [modeOfSalaryOptions, setModeOfSalaryOptions] = useState([]);
  const [currentOccupationOptions, setCurrentOccupationOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [hasCriteriaFields, setHasCriteriaFields] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchedPincodeList, setSearchedPincodeList] = useState([]);
  const [searchedCompanyList, setSearchedCompanyList] = useState([]);
  const [additionalFields, setAdditionalFields] = useState([]);
  const [workExpOptions, setWorkExpOptions] = useState([]);
  const [bankNames,setBankNames]=useState([]);
  
  const [selectModeOfIncome,setSelectModeOfIncome]=useState("");

  const {flags} = useContext(FeatureFlagContext);
  
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Fetching brand details from the session storage

  let partnerDetails = JSON.parse(sessionStorage.getItem("partnerDetails"));

  // const [hasDoneApi]
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  const query = useQuery();
  // Regex
  //   const phoneRegExp = /^[1-9]{1}[0-9]{9}$/;
  // const numberReg = /^[1-9]{1}[0-9]{5}$/;
  // const emailReg = /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;
  // const emailReg =
  //   /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  // const numberReg = /^\d+$/;
  //   const panRegex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;

  let addRegex = {};
  additionalFields.forEach((f) => {
    addRegex = {
      ...addRegex,
      [f]: Yup.string().required("Required"),
    };
  });

  const customerSchema = Yup.object({
    // ...addRegex,
    // pinCode: Yup.string()
    //   .matches(numberReg, "Invalid pincode")
    //   .test("", "Invalid pincode", (value) =>
    //     searchedPincodeList?.includes(value)
    //   )
    //   .required("Required"),
      // employerName: Yup.string().required("Required"),
    fullName: Yup.string().matches(isCharWithoutSymbol, "Special characters not allowed"),
    workExperience: customerDetails?.employmentType == "Not Working" ? Yup.string().nullable() : Yup.string().required("Required"),
    // email: Yup.string().required("Required"),
    gender: Yup.string().required("Required"),
    annualIncome: customerDetails?.employmentType == "Not Working" ? Yup.string().nullable() : Yup.string().required("Required"),
    // email: Yup.string().trim()
    //   .matches(emailReg, "Invalid Email Format")
    //   .required("Email Required"),
    employerName: customerDetails?.employmentType == "Not Working" ? Yup.string().nullable() : Yup.string().required("Required"),
    currentOccupation: customerDetails?.employmentType == "Not Working" ? Yup.string().nullable() : Yup.string().required("Required"),
    bankNameList: customerDetails?.modeOfIncome !=="Cash" && flags?.bank_name_field?.value == "show" ? Yup.array().required("Required") : Yup.array().nullable(),
  });

  const getCustomerExistingDetails = async () => {
    try {
      setLoading(true);
      const hash = encodeURIComponent(searchParams.get("hash"));
      const res = await onecodeAPI.post(`/public/customer/findByHash`, {
        hash: hash,
      });
      // console.log("res=============",res);
      let missingFileds = res?.data?.missingFields ?? [];
      setAdditionalFields(missingFileds);
      setCustomerDetails(res.data);
      setSelectModeOfIncome(res?.data?.modeOfIncome);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("errror-customer", error);
    }
  };

  const criteriaFieldsStates = {
    income: (v) => setIncomeOptions(v),
    employmentType: (v) => setEmploymentTypeOptions(v),
    modeOfSalary: (v) => setModeOfSalaryOptions(v),
    bankName:(v) => setBankNames(v),
    currentOccupation: (v) => setCurrentOccupationOptions(v),
    category: (v) => setCategoryOptions(v),
    experian: () => {},
    age: () => {},
    Equifax: () => {},
    CIBIL: () => {},
    Experian: () => {},
    dpd: () => {},
    creditHistory: () => {},
    workExperience: (v) => setWorkExpOptions(v),
  };

  const fetchFields = async () => {
    try {
      const res = await onecodeAPI.get(`/criteria/fields?locale=${i18n?.language || "en"}`);
      // console.log("res====",res);
      _.forEach(res.data, (criteria) => {
        criteriaFieldsStates[criteria?.criteriaName](criteria.indexes);
      });
      setHasCriteriaFields(true);
    } catch (error) {
      setLoading(false);
      console.log("error-field", error);
    }
  };

  useEffect(() => {
    getCustomerExistingDetails();
    fetchFields();
    window?.Moengage?.track_event("bank_name_field_flag", {
      value: flags?.bank_name_field?.value,
    });
  }, []);

  const getValueByLabel = (label, criteria) => {
    const criteriaOptions = {
      incomeOptions: incomeOptions,
      employmentTypeOptions: employmentTypeOptions,
      modeOfSalaryOptions: modeOfSalaryOptions,
      bankNameOptions:bankNames,
      currentOccupationOptions: currentOccupationOptions,
      categoryOptions: categoryOptions,
      workExpOptions: workExpOptions,
    };
    if (criteria === "categoryOptions") {
      const selectedCriteriaOptions = _.filter(
        criteriaOptions[criteria],
        (co) => co.label === label
      );
      const selectedCategories = _.map(
        selectedCriteriaOptions,
        (so) => so.value
      );
      // console.log("selectedCategories========", selectedCategories);
      return selectedCategories;
    } else {
      const selectedCriteriaOption = _.filter(
        criteriaOptions[criteria],
        (co) => co.label === label
      )[0];
      return selectedCriteriaOption?.value;
    }
  };

  const formik = useFormik({
    initialValues: {
      panNo: customerDetails?.panNo,
      fullName: customerDetails?.fullName,
      // dob: "",
      gender: "",
      // pinCode: "",
      annualIncome: "",
      // email: "",
      employerName: customerDetails?.employerNameEpf || "",
      workExperience: "",
      employmentType: getValueByLabel(
        customerDetails?.employmentType,
        "employmentTypeOptions"
      ),
      modeOfIncome: getValueByLabel(
        customerDetails?.modeOfIncome,
        "modeOfSalaryOptions"
      ),
      bankNameList:[],
      currentOccupation: "",
      twoWheelerNo: "",
      fourWheelerNo: "",
      interestedCategories: [],
      // employerName:"",
      // workExperience:"",
      // email:""
    },
    enableReinitialize: true,
    validationSchema: customerSchema,
    onSubmit: async (values) => {
      setSubmitLoading(true);
      let customerObj = {
        ...values,
        // email:values.email.trim(),
        employerName: values.employerName,
        bankNameList:values.bankNameList.length > 0 ? values.bankNameList : null,
        // .join(),
        interestedCategories: values.interestedCategories.join(),
        phoneNumber: customerDetails.phoneNumber,
        // dateOfBirth: values.dob ? formik.values.dob : null,
        // dob: null,
      };
      // console.log(customerObj,"customer");
      let hash = encodeURIComponent(searchParams.get("hash"));

      // setCurrentScreen(1);
      try {
        onecodeAPI.defaults.timeout = 4000;
        let response = await onecodeAPI.post("/public/customer/addCustomer", {
          hash: hash,
          customer: customerObj,
          addedByCreditScore:
            sessionStorage.getItem("isCreditScoreCheck") || false,
        });
        // let addCustomerResponse = {
        //   ...response,
        //   data: { ...response?.data, ...response?.data?.result },
        //   customer: hash
        // };
        // dispatch(
        //   customerActions.setRecommendationData(addCustomerResponse)
        // )
        dispatch(customerActions.setAddCustomerFlow(true));
        navigate(`/customer/recommendations`, {
          state: {
            hash: searchParams.get("hash"),
            isCreditScoreCheck: isCreditScoreCheck,
          },
        });
        setSubmitLoading(false);
      } catch (error) {
        if(error?.response?.data?.status==2029){
          message.error(error?.response?.data?.message);
        }else{
          message.error("Error","Please try again after some time.")
        }

        if(error.isAxiosError && error.message === 'timeout of 4000ms exceeded') {
          dispatch(
            customerActions.setRecommendationData(null)
          )
          navigate(`/customer/recommendations`, {
            state: {
              hash: searchParams.get("hash"),
              isCreditScoreCheck: isCreditScoreCheck,
            },
          });
        }
        
        setSubmitLoading(false);
      }
    },
  });

  useEffect(() => {
    if (hasCriteriaFields && customerDetails) {
      formik.setValues({
        panNo: customerDetails?.panNo,
        fullName: customerDetails?.fullName,
        // pinCode: "",
        employerName:"",
        annualIncome: getValueByLabel(
          customerDetails?.annualIncome,
          "incomeOptions"
        ),
        // email: "",
        employerName: customerDetails?.employerNameEpf || "",
        employmentType: getValueByLabel(
          customerDetails?.employmentType,
          "employmentTypeOptions"
        ),
        modeOfIncome: getValueByLabel(
          customerDetails?.modeOfIncome,
          "modeOfSalaryOptions"
        ),

        bankNameList:[],
        //  getValueByLabel(
        //   customerDetails?.bankNames,
        //   "bankNameOptions"
        // ) || [],

        currentOccupation: getValueByLabel(
          customerDetails?.currentOccupation,
          "currentOccupationOptions"
        ),
        twoWheelerNo: customerDetails?.twoWheelerNo,
        fourWheelerNo: customerDetails?.fourWheelerNo,
        interestedCategories:
          getValueByLabel(
            customerDetails?.interestedCategories,
            "categoryOptions"
          ) || [],
        gender: "",
        workExperience: "",
        //   employerName : "" ,
        //   workExperience:getValueByLabel(
        //     customerDetails?.workExperience,
        //               "workExpOptions"
        //             ) ,
        // email :  ""
      });
    }
  }, [customerDetails, hasCriteriaFields]);

  const genderLabel = [
    { label: "Male", value: "Male", localizedLabel: "Male" },
    { label: "Female", value: "Female", localizedLabel: "Female" },
  ];

  
  return (
    <>
      {/* <div className="WatchVideo">
        <WatchVideo
          videoTitle={"Why details ?"}
          videoId={"jrHbo8I1kkU"}
          eventName={"add-customer_customer_watch_video"}
          name="Why details ?"
        />
      </div> */}
      <div className="lastFormContainer">
        {/* <Space> */}
        {loading ? (
          <Spin size="large" />
        ) : (
          <form
            onSubmit={formik.handleSubmit}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              //   border: "1px solid red",
              width: "100%",
            }}
          >
            <CustomInput
              label={t("addcustomertotalinformation.pannumber")}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.panNo}
              name="panNo"
              readonly={true}
            />
            {formik.touched.panNo && formik.errors.panNo ? (
              <div className="error">{formik.errors.panNo}</div>
            ) : null}
            <CustomInput
              label={t("addcustomertotalinformation.nameasperpan")}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.fullName}
              name="fullName"
              readonly={false}
            />
            {formik.touched.fullName && formik.errors.fullName ? (
              <div className="error">{formik.errors.fullName}</div>
            ) : null}

            {/* <CustomInput
              label={"Email"}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.email.trim()}
              name="email"
              // readonly={false}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className="error">{formik.errors.email}</div>
            ) : null} */}

            {customerDetails?.employmentType !== "Not Working" ? (
              <>
                <CustomInput
                  label={"Company Name"}
                  handleChange={(option) => {
                    formik.setFieldValue("employerName", option);
                  }}
                  handleBlur={formik.handleBlur}
                  value={formik.values.employerName}
                  name="employerName"
                  readonly={formik.initialValues.employerName ? true : false}
                />
                {formik.touched.employerName && formik.errors.employerName ? (
                  <div className="error">{formik.errors.employerName}</div>
                ) : null}
                <DropDown
                  label={"Work Experience"}
                  data={workExpOptions}
                  handleChange={(option) =>
                    formik.setFieldValue("workExperience", option.value)
                  }
                  handleBlur={formik.handleBlur}
                  value={formik.values.workExperience}
                  name="workExperience"
                />
                {formik.touched.workExperience &&
                formik.errors.workExperience ? (
                  <div className="error">{formik.errors.workExperience}</div>
                ) : null}
              </>
            ) : (
              <></>
            )}
            <DropDown
              label={t("addcustomertotalinformation.gender")}
              data={genderLabel}
              handleChange={(option) =>
                formik.setFieldValue("gender", option.value)
              }
              handleBlur={formik.handleBlur}
              value={formik.values.gender}
              name="Gender"
            />
            {formik.touched.gender && formik.errors.gender ? (
              <div className="error">{formik.errors.gender}</div>
            ) : null}

            {/* *************************************** */}
            { selectModeOfIncome == "Bank" && flags?.bank_name_field?.value == "show"  ?
             <MultiSelect
              label={"Bank name"}
              data={bankNames}
              handleInterests={formik.setFieldValue}
                handleBlur={formik.handleBlur}
                interestsArray={formik.values.bankNameList}
                name="bankNameList"
              /> : null}
            {/* ********************************************** */}
            {/* <CustomInput
              label={t("addcustomertotalinformation.pincode")}
              handleChange={(option) => {
                formik.setFieldValue("pinCode", option);
              }}
              handleBlur={formik.handleBlur}
              value={formik.values.pinCode}
              name="pinCode"
              readonly={false}
              text="number"
              setSearchedPincodeList={setSearchedPincodeList}
            />
            {formik.touched.pinCode && formik.errors.pinCode ? (
              <div className="error">{formik.errors.pinCode}</div>
            ) : null} */}
            {/* <DropDown
              data={employmentTypeOptions}
              label={t("addcustomertotalinformation.employmenttype")}
              handleChange={(option) =>
                formik.setFieldValue("employmentType", option.value)
              }
              handleBlur={formik.handleBlur}
              value={formik.values.employmentType}
              name="employmentType"
            />
            {formik.touched.employmentType && formik.errors.employmentType ? (
              <div className="error">{formik.errors.employmentType}</div>
            ) : null}
            <DropDown
              data={workExpOptions}
              label={"Work Experience"}
              handleChange={(option) =>
                formik.setFieldValue("workExperience", option.value)
              }
              handleBlur={formik.handleBlur}
              value={formik.values.workExperience}
              name="workExperience"
            />
            {formik.touched.workExperience && formik.errors.workExperience ? (
              <div className="error">{formik.errors.workExperience}</div>
            ) : null}
            {/* <DropDown
              data={modeOfSalaryOptions}
              label={t("addcustomertotalinformation.modeofincome")}
              handleChange={(option) =>
                formik.setFieldValue("modeOfIncome", option.value)
              }
              handleBlur={formik.handleBlur}
              // value={formik.values.modeOfIncome}
              name="modeOfIncome"
              value={
                formik.values.employmentType == 4
                  ? "0"
                  : formik.values.modeOfIncome
              }
              disable={formik.values.employmentType == 4 ? true : false}
            />
            {formik.touched.modeOfIncome && formik.errors.modeOfIncome ? (
              <div className="error">{formik.errors.modeOfIncome}</div>
            ) : null} */}
            <DropDown
              data={incomeOptions}
              label={t("addcustomertotalinformation.Monthlyincome")}
              handleChange={(option) =>
                formik.setFieldValue("annualIncome", option.value)
              }
              handleBlur={formik.handleBlur}
              // value={formik.values.annualIncome}
              name="annualIncome"
              value={
                formik.values.employmentType == 4
                  ? "0"
                  : formik.values.annualIncome
              }
              disable={formik.values.employmentType == 4 ? true : false}
            />
            {formik.touched.annualIncome && formik.errors.annualIncome ? (
              <div className="error">{formik.errors.annualIncome}</div>
            ) : null}
            <DropDown
              data={currentOccupationOptions}
              label={t("addcustomertotalinformation.occupation")}
              handleChange={(option) =>
                formik.setFieldValue("currentOccupation", option.value)
              }
              handleBlur={formik.handleBlur}
              // value={formik.values.currentOccupation}
              name="currentOccupation"
              value={
                formik.values.employmentType == 4
                  ? getValueByLabel("Not working", "currentOccupationOptions")
                  : formik.values.currentOccupation
              }
              disable={formik.values.employmentType == 4 ? true : false}
            />
            {formik.touched.currentOccupation &&
            formik.errors.currentOccupation ? (
              <div className="error">{formik.errors.currentOccupation}</div>
            ) : null}
            {/* <CustomInput
              label={"Your 2 wheeler number (Optional)"}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.twoWheelerNo}
              name="twoWheelerNo"
              readonly={false}
            />{" "}
            <CustomInput
              label={"Your 4 wheeler number (Optional)"}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              value={formik.values.fourWheelerNo}
              name="fourWheelerNo"
              readonly={false}
            /> */}
            
            <div
              className="termsContainer"
              //
            >
              <div
                onClick={() => {
                  setTermsChecked(!termsChecked);
                  window?.Moengage?.track_event(
                    "add-customer_customer_termsofuseprivacypolicy_check"
                  );
                }}
              >
                <input
                  type="checkbox"
                  style={{
                    width: "18px",
                    height: "18px",
                    backgroundColor: "red",
                  }}
                  checked={termsChecked}
                />
              </div>
              <div>
                I agree to the
                <a
                  href
                  style={{ color: "#6C63FF" }}
                  onClick={() => {
                    window?.Moengage?.track_event(
                      "add-customer_customer_termsofuse_click"
                    );
                    window.open(
                      "https://onecode-asset.s3.ap-south-1.amazonaws.com/Web+site-T%26C-Policies/EndUsersEULA-OneCode.html",
                      "_blank"
                    );
                  }}
                >
                  {" "}
                  Terms of Use{" "}
                </a>
                &
                <a
                  href
                  style={{ color: "#6C63FF" }}
                  // onClick={window?.Moengage?.track_event("add-customer_customer_privacypolicy_click")}
                  onClick={() => {
                    window?.Moengage?.track_event(
                      "add-customer_customer_privacypolicy_click"
                    );
                    window.open(
                      "https://onecode-asset.s3.ap-south-1.amazonaws.com/Web+site-T%26C-Policies/EndUsersPrivacyPolicy-OneCode+.html",
                      "_blank"
                    );
                  }}
                >
                  {" "}
                  Privacy Policy
                </a>
              </div>
            </div>
            <button
              type="submit"
              style={{
                background: termsChecked ? "#6C63FF" : "#c2c2c2",
                border: "none",
                color: "white",
                padding: 12.5,
                borderRadius: 5,
                margin: "auto",
                width: "85%",
                marginTop: "10px",
              }}
              disabled={(!termsChecked)||submitLoading}
              onClick={() =>
                window?.Moengage?.track_event(
                  "add-customer_customer_continue_2",
                  {
                    customer_ID: customerDetails?.id,
                    customer_phone: customerDetails?.phoneNumber,
                    customer_name_as_PAN: formik.values?.fullName,
                    customer_PIN_Code: formik.values?.pinCode,
                    customer_annaul_income: formik.values?.annualIncome,
                    customer_employment_type: formik.values?.employmentType,
                    customer_income_mode: formik.values?.modeOfIncome,
                    customer_occupation: formik.values?.currentOccupation,
                    customer_interested_categories:
                      formik.values.interestedCategories,
                  }
                )
              }
            >
              {submitLoading ? <LoadingOutlined size={"large"} /> : null}
              {t("addcustomertotalinformation.Apply")}
            </button>
          </form>
        )}
      </div>
    </>
  );
}
